import { render, staticRenderFns } from "./DepartmentParent.vue?vue&type=template&id=53fff060&"
import script from "./DepartmentParent.vue?vue&type=script&lang=js&"
export * from "./DepartmentParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports